import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

export type ZustandLookup = {
  id: number;
  code: string;
  label: string;
  farbe: string | null;
  sort_order: number;
  ist_endzustand: boolean;
};

/**
 * Die gepflegte Zustandsliste.
 *
 * Als eigener Hook, weil sie an zwei Stellen gebraucht wird: der
 * ZustandSwitcher baut daraus sein Menü, und der Verlauf braucht sie, um
 * die Zustands-IDs seiner Einträge in Codes aufzulösen (A11.2). Beide
 * teilen sich denselben Query-Schlüssel — es entsteht kein zweiter
 * Abruf.
 */
export function useZustaende() {
  return useQuery({
    queryKey: ['lookups', 'zustaende'],
    queryFn: () =>
      apiFetch<{ type: string; items: ZustandLookup[] }>('/lookups.php?type=zustaende'),
    staleTime: 10 * 60_000
  });
}
